import { cva } from '@/styled-system/css';

export const assistChipRootRecipe = cva({
  base: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
    boxShadowColor: { base: 'border.action.neutral.default' },
    borderRadius: 'shape.capsule',
    paddingInline: 'Chip.padding.horz',
    paddingBlock: 'Chip.padding.vert',
    backgroundColor: { base: 'bg.action.neutral.default' },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease',
    },
    minWidth: '0',
    cursor: 'pointer',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
    elevated: {
      true: {},
      false: {},
    },
    loading: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: [true, false],
      loading: true,
      css: {
        opacity: 1,
        cursor: 'default',
      },
    },
    {
      disabled: true,
      loading: false,
      css: {
        cursor: 'default',
      },
    },
    {
      disabled: false,
      loading: false,
      css: {
        backgroundColor: {
          _hover: 'bg.action.neutral.hover',
          _active: 'bg.action.neutral.pressed',
        },
        boxShadowColor: {
          _hover: 'border.action.neutral.hover',
          _active: 'border.action.neutral.pressed',
        },
        _after: {
          content: '""',
          position: 'absolute',
          height: 'tapArea.mobile.sm',
          minWidth: 'tapArea.mobile.sm',
          width: '100%',
          left: '0',
          top: '50%',
          marginTop: 'calc(({sizes.tapArea.mobile.sm} / 2) * -1)',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      css: {
        backgroundColor: {
          base: 'bg.elevated.action.smallShadow.default',
        },
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.sm}',
        },
      },
    },
    {
      elevated: true,
      loading: false,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'Chip.bg.elevated.hover',
          _active: 'Chip.bg.elevated.pressed',
        },
        boxShadow: {
          _hover: {
            base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusVisible:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.none}',
          _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    {
      elevated: true,
      loading: true,
      css: {
        backgroundColor: 'bg.elevated.action.smallShadow.default',
        boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.sm}',
      },
    },
  ],
});
